"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var PostContext = /*#__PURE__*/_react["default"].createContext({
  name: "post",
  user: null,
  post: null,
  parentRoute: null,
  statusManager: null,
  page: ""
});
var _default = PostContext;
exports["default"] = _default;